/**
 * returns the 2 biggest duration units eg:
 *     "{n}d {n}h"
 *     "{n}h {n}m"
 *     "{n}m {n}s"
 */
export const useTwoUnitCountdownFormat = (timeLeft: Ref<Countdown | "">) => {
  const { t } = useI18n();

  return computed(() => {
    if (!timeLeft.value) {
      return timeLeft.value;
    }

    const { days, minutes, hours, seconds } = timeLeft.value;

    if (days > 0) {
      return `${days}${t("countdownTimer.days")} ${hours}${t(
        "countdownTimer.hours",
      )}`;
    }

    if (hours > 0) {
      return `${hours}${t("countdownTimer.hours")} ${minutes}${t("countdownTimer.minutes")}`;
    }

    return `${minutes}${t("countdownTimer.minutes")} ${seconds}${t("countdownTimer.seconds")}`;
  });
};
